import { Spinner as BaseSpinner } from "@chakra-ui/react";

export default BaseSpinner;
